import { Component, OnInit, HostListener, Renderer2, EventEmitter, Output } from '@angular/core';
import { SharedService } from '../../services/core/shared.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  showSearchPanel = false;
  searchText = '';
  //@Output() filterChange = new EventEmitter();

  constructor(
    private sharedService:SharedService,  
    private renderer2: Renderer2) { }

  ngOnInit() {
  }

  onClickSearchBtn() {
    this.showSearchPanel = !this.showSearchPanel;
    this.searchText ='';
    if(this.showSearchPanel){
      setTimeout(() => {
        let element = document.getElementById('search-id');
        element.focus();
      }, 100)
    }
  }

  keyPress(event: KeyboardEvent) {
    
    const inputChar = String.fromCharCode(event.charCode);
    //this.searchText += inputChar;
    //console.log(inputChar);
    if(event.charCode == 13){
      console.log(this.searchText);
      this.sharedService.nextData({"name":"searchText","value":""+this.searchText});
      //this.filterChange.emit(this.searchText);      
    }
    /*const pattern = /[0-9]/;
    if (!pattern.test(inputChar)) {    
        // invalid character, prevent input
        event.preventDefault();
    }*/
  }


  @HostListener("window:scroll", [])
  onWindowScroll() {
    //console.log("Scrolling! "+window.scrollY);
    if (window.scrollY > 200) {

    }
  }

  /**@HostListener('window:scroll', ['$event']) onWindowScroll(e) {
    console.log(e.target['scrollingElement'].scrollTop)

    // Your Code Here

  } */

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/section/header/header.component.ts